// import { domain } from '@/config';

const cookieName = 'cookieName';

export const setCookie = (name, value, hour = 2) => {
  const expires = `expires=${new Date(Date.now() + hour * 60 * 60 * 1000).toUTCString()}`;

  document.cookie = `${name}=${value};${expires};path=/`;
};

export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));

  if (match) {
    return match[2];
  }

  return '';
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=;${new Date().toUTCString()};path=/`;
};

export const deleteAuthCookie = () => {
  deleteCookie(cookieName);
};

export const getAuthCookie = () => {
  try {
    return getCookie(cookieName);
  } catch (_) {
    return '';
  }
};
